import type { Field } from '@puckeditor/core';

import { lookup } from './tokens';

export const TEXT_WEIGHTS = {
  normal: 'var(--dcm-cms-text-weight-normal, 400)',
  medium: 'var(--dcm-cms-text-weight-medium, 500)',
  semibold: 'var(--dcm-cms-text-weight-semibold, 600)',
  bold: 'var(--dcm-cms-text-weight-bold, 700)',
} as const;

export type TextWeight = keyof typeof TEXT_WEIGHTS | 'system';

export const TEXT_WEIGHT_FIELD: Field<TextWeight> = {
  type: 'select',
  label: 'Font weight',
  options: [
    { label: 'Default', value: 'system' },
    { label: 'Normal', value: 'normal' },
    { label: 'Medium', value: 'medium' },
    { label: 'Semibold', value: 'semibold' },
    { label: 'Bold', value: 'bold' },
  ],
};

export const CUSTOM_TEXT_SIZE_FIELD: Field<number> = {
  type: 'number',
  label: 'Custom size (px)',
  min: 8,
  max: 200,
  step: 1,
};

export function customTextSizeCss(value: unknown, defaultSize: number): string {
  const pixels = typeof value === 'number' && Number.isFinite(value) ? value : defaultSize;
  return `${Math.min(200, Math.max(8, Math.round(pixels)))}px`;
}

export function textWeightCss(weight: TextWeight): string | undefined {
  return lookup(TEXT_WEIGHTS, weight, undefined);
}
